import powerbank from '../../assets/muvtech/HeroImages/heroImg1.png';
import micstand from '../../assets/muvtech/HeroImages/micstand.png';
import logo from '../../assets/muvtech/HeroImages/logo.png';
import typeCcable from '../../assets/muvtech/HeroImages/typeCtoC.png';
import mobileCase from '../../assets/muvtech/HeroImages/mobileCase.png';

import MuvtechCate from './MuvtechCate';

// export const muvtechCategories = [
//   { id: 1, name: 'IPHONE CASES' },
//   { id: 2, name: 'Power Bank' },
//   { id: 3, name: 'Charger' },
//   { id: 4, name: 'Cables' },
//   { id: 5, name: 'Cases' },
//   { id: 6, name: 'BagPack' },
//   { id: 7, name: 'Hub' },
// ];

const MuvtechHero = () => {
  // const navigate = useNavigate();
  return (
    <div className="muvtech-container">
      {/* <div className="category-buttons">
        {muvtechCategories.map((category) => (
          <button
            key={category?.id}
            className="category-button"
          >
            {category?.name}
          </button>
        ))}
      </div> */}
      <div className="muvcate">
        <MuvtechCate />
      </div>

      <div className="hero-layout">
        <img src={powerbank} className="product top-left" alt="Product" />
        <img src={typeCcable} className="product bottom-left" alt="Product" />
        <img src={logo} className="logo-center" alt="Logo" />
        <img src={mobileCase} className="product top-right" alt="Product" />
        <img
          src={micstand}
          className="product bottom-right"
          // style={{ maxWidth: '600px' }}
          alt="Product"
        />
      </div>
    </div>
  );
};

export default MuvtechHero;
